
const providercreditBackdrop        = require('./providercredit-backdrop')
const providercreditConfirmation    = require('./providercredit-confirmation')
const providercreditDialog          = require('./providercredit-dialog')
const providercreditDt              = require('./providercredit-dt')
const providercreditFullcont        = require('./providercredit-fullcont')
const providercreditMenu            = require('./providercredit-menu')
const providercreditPage            = require('./providercredit-page')
const providercreditSnack           = require('./providercredit-snack')
const providercreditMT              = require('./providercredit-fullcont-multitable')




export function start(detail){  

         
      obj[detail.elem].start(detail)

}/**/




const obj = {
   
      backdrop:        { start: (detail)=>{  providercreditBackdrop.start(detail)         }},
      confirmation:    { start: (detail)=>{  providercreditConfirmation.start(detail)     }},
      dialog:          { start: (detail)=>{  providercreditDialog.start(detail)           }},
      dt:              { start: (detail)=>{  providercreditDt. start(detail)              }},
      fullcont:        { start: (detail)=>{  providercreditFullcont.start(detail)        }},
      multitable:      { start: (detail)=>{  providercreditMT.start(detail)               }},
      menu:            { start: (detail)=>{  providercreditMenu.start(detail)             }},
      page:            { start: (detail)=>{  providercreditPage.start(detail)             }},
      snack:           { start: (detail)=>{  providercreditSnack.start(detail)            }},

}